import { IconTarget, IconStar, IconTrend, IconShield } from './icons'

export interface Pillar {
  number: string
  label: string
  icon: () => React.ReactNode
  title: string
  description: string
  tags: string[]
}

export const PILLARS: Pillar[] = [
  {
    number: '01',
    label: 'Our Mission',
    icon: IconTarget,
    title: 'Making Quran Learning Accessible to Everyone',
    description:
      'We aim to make learning the Quran simple, accessible, and personalized for Muslims around the world. Through qualified teachers and flexible online learning, we help every student take meaningful steps toward a stronger connection with the Quran.',
    tags: ['Accessible Learning', 'Qualified Teachers', 'Flexible Schedules'],
  },
  {
    number: '02',
    label: 'Our Vision',
    icon: IconStar,
    title: 'A World Connected Through the Quran',
    description:
      'We envision a global community where every Muslim can learn, recite, understand, and live by the Quran with confidence—regardless of age, language, or level.',
    tags: ['Global Community', 'All Ages & Levels', 'Confident Recitation'],
  },
  {
    number: '03',
    label: 'Our Values',
    icon: IconShield,
    title: 'Faith, Excellence & Sincerity',
    description:
      'We believe in sincere teaching, excellence in learning, patience with every student, and creating a respectful environment where learners can grow spiritually and academically.',
    tags: ['Sincere Teaching', 'Spiritual Growth', 'Respectful Environment'],
  },
  {
    number: '04',
    label: 'Our Promise',
    icon: IconTrend,
    title: 'Your Journey. Your Goals. Our Support.',
    description:
      "Every learner is different. That's why we provide personalized guidance, dedicated teachers, and continuous support to help you achieve your Quran and Islamic learning goals—step by step.",
    tags: [
      'Personalized Guidance',
      'Dedicated Teachers',
      'Step-by-Step Growth',
    ],
  },
]
